import { useEffect } from 'react';

/**
 * Uses an action as an effect.
 * @param action A function to be called as a hook effect.
 * Unlike useEffect, the action can return a value, which is ignored.
 * This allows Satchel actions to be used as effect without extra syntax in the component code.
 */
export function useAction(action: () => any): void {
    useEffect(() => {
        action();
    }, [action]);
}
